export default __webpack_public_path__ + "static/banner-859244f641c6429f5e9fd3b195287b8a.png";